import styled from "styled-components";

export const ContainerAsociarme = styled.div`
  padding: 24px 40px;
  .customCss {
    background: linear-gradient(
        0deg,
        rgba(230, 229, 229, 0.2),
        rgba(230, 229, 229, 0.2)
      ),
      #f1f1f1;
    box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25), 0px 4px 4px rgba(0, 0, 0, 0.25),
      0px 4px 4px rgba(0, 0, 0, 0.25),
      0px 6.00101px 4.80081px rgba(0, 0, 0, 0.0282725),
      0px 2.49716px 1.99772px rgba(0, 0, 0, 0.0196802);
    border-radius: 7.21915px;
  }
`;
export const ContainerLogueo = styled.div`
  padding: 24px 40px;
  display: flex;
  flex-direction: column;
  gap: 22px;
`;

export const ContainerInformacion = styled.div`
  padding: 24px 40px;
  .customCss {
    background: linear-gradient(
        0deg,
        rgba(230, 229, 229, 0.2),
        rgba(230, 229, 229, 0.2)
      ),
      #f1f1f1;
    box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25), 0px 4px 4px rgba(0, 0, 0, 0.25),
      0px 4px 4px rgba(0, 0, 0, 0.25),
      0px 6.00101px 4.80081px rgba(0, 0, 0, 0.0282725),
      0px 2.49716px 1.99772px rgba(0, 0, 0, 0.0196802);
    border-radius: 7.21915px;
  }
`;

export const BtnContainer = styled.div`
  display: flex;
  gap: 20px;
  justify-content: center;
`;

export const BtnEnviar = styled.button`
  width: 70px;
  height: 30px;
  box-shadow: 0px 90.2394px 72.1915px rgba(0, 0, 0, 0.07),
    0px 37.6999px 30.1599px rgba(0, 0, 0, 0.0503198),
    0px 20.1562px 16.1249px rgba(0, 0, 0, 0.0417275),
    0px 11.2994px 9.0395px rgba(0, 0, 0, 0.035),
    0px 6.00101px 4.80081px rgba(0, 0, 0, 0.0282725),
    0px 2.49716px 1.99772px rgba(0, 0, 0, 0.0196802);
  border-radius: 7.21915px;
`;

export const BtnLogueo = styled.button`
  width: 120px;
  height: 36px;
  box-shadow: 0px 90.2394px 72.1915px rgba(0, 0, 0, 0.07),
    0px 37.6999px 30.1599px rgba(0, 0, 0, 0.0503198),
    0px 20.1562px 16.1249px rgba(0, 0, 0, 0.0417275),
    0px 11.2994px 9.0395px rgba(0, 0, 0, 0.035),
    0px 6.00101px 4.80081px rgba(0, 0, 0, 0.0282725),
    0px 2.49716px 1.99772px rgba(0, 0, 0, 0.0196802);
  border-radius: 7.21915px;
`;
